function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Options({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.311 16.484a3.316 3.316 0 013.312 3.313 3.316 3.316 0 01-3.312 3.313 3.315 3.315 0 01-3.31-3.313 3.316 3.316 0 013.31-3.313zm0 2.001a1.313 1.313 0 10.003 2.625 1.313 1.313 0 00-.003-2.625zm0-9.743a3.316 3.316 0 013.312 3.313 3.316 3.316 0 01-3.312 3.313 3.315 3.315 0 01-3.31-3.313 3.316 3.316 0 013.31-3.313zm0 2a1.313 1.313 0 10.003 2.626 1.313 1.313 0 00-.003-2.625zm0-9.741a3.316 3.316 0 013.312 3.313 3.316 3.316 0 01-3.312 3.313 3.316 3.316 0 01-3.31-3.313A3.315 3.315 0 0112.31 1zm0 2a1.313 1.313 0 000 2.625 1.313 1.313 0 000-2.625z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoOptions = React.memo(Options);
export default MemoOptions;